import { updateCurrentPage } from "SiteLayout/CurrentPage/action-creators";
import { postJson, post, getJson } from "Shared/server";
import { currentUrl, pathCombine } from "Shared/url";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { recipeOverviewPageUrl } from "Shared/known-urls";
import { clear as clearCache } from "SiteLayout/CurrentPage/cache";
import { pushState, replaceState } from "Shared/history";
export const UPDATE_SHOPPINGLIST = "UPDATE_SHOPPINGLIST";
export const CLEAR_SHOPPINGLIST = "CLEAR_SHOPPINGLIST";
export const INIT_SHOPPINGLIST = "INIT_SHOPPINGLIST";
export function updatePortions(portions) {
    return (dispatch) => {
        return getJson(currentUrl().path + "?numberOfPortions=" + portions).then((resp) => dispatch(updateCurrentPage((current) => Object.assign(current, {
            recipeItemModels: resp.recipeItemModels.map((item) => Object.assign({}, item)),
            allMealRecipeModels: resp.allMealRecipeModels.map((item) => Object.assign({}, item)),
            portionCost: resp.portionCost,
        }))));
    };
}
export function shareRecipe(model) {
    return (dispatch) => {
        return postJson("/ShareRecipeApi/Share", model).then((resp) => {
            return resp;
        });
    };
}
export function searchUsers(query) {
    return (dispatch) => {
        return postJson("/SearchContactApi/Search", query).then((resp) => {
            return resp;
        });
    };
}
export const removeRecipe = (id) => (dispatch, getState) => post(`${getState().appShellData.siteSettings.recipeOverviewPage.url}/delete`, id)
    .then((result) => {
    if (result.type === "error") {
        dispatch(setFeedback(result));
        return Promise.reject(null);
    }
    return clearCache(recipeOverviewPageUrl().url).then(() => replaceState(recipeOverviewPageUrl().url, { hideSpinner: true }).then(() => Promise.resolve()));
})
    .catch(failedPromiseHandler);
export function fetchShoppinglist(portions) {
    const nameKey = currentUrl().path.replace(recipeOverviewPageUrl().url, "");
    return (dispatch) => {
        return postJson(pathCombine("/recipe", "/RecipeToShoppingList?recipename=" + nameKey.replace("/", "")), portions).then((resp) => {
            let shoppingList = [];
            if (resp.items) {
                resp.items.forEach((item) => {
                    let product = !!item.product.isDiscontinued || !!item.product.isBackorderReplaced
                        ? item.product.replacementProduct
                        : item.product;
                    if (!!product && item.quantity > 0) {
                        shoppingList.push({
                            code: item.selectedVariant.code,
                            quantity: item.quantity,
                            unitShortName: item.selectedVariant.unitShortName,
                            ticket: item.selectedVariant.ticket,
                        });
                    }
                });
                dispatch(initShoppingList(shoppingList));
            }
            return Promise.resolve(resp);
        });
    };
}
export function updateShoppingList(code, quantity, unitShortName) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_SHOPPINGLIST,
            code,
            quantity,
            unitShortName,
        });
        return Promise.resolve();
    };
}
export const clearShoppingList = () => {
    const clearAction = { type: CLEAR_SHOPPINGLIST };
    return clearAction;
};
export const initShoppingList = (shoppingList) => {
    const initAction = {
        type: INIT_SHOPPINGLIST,
        shoppingList,
    };
    return initAction;
};
export const cancelEdit = (id) => {
    post({
        path: `${recipeOverviewPageUrl()}/CancelEdit`,
        query: { id: id },
    }).then((data) => {
        pushState(recipeOverviewPageUrl().url);
    });
};
let lastRequestId = 0;
export function notifySelectionChangesToServer(recipeModel) {
    const requestId = (lastRequestId = Math.random());
    return (dispatch) => {
        postJson(pathCombine("/recipe", "/update"), recipeModel)
            .then((result) => {
            if (requestId === lastRequestId) {
                if (!!result.errorMessages) {
                    return dispatch(setFeedback({
                        text: result.errorMessages.join(" "),
                        type: "error",
                    }));
                }
                return dispatch(updateCurrentPage((current) => Object.assign(current, {
                    recipeModel: Object.assign(current.recipeModel, {
                        recipeItemModels: result.recipeItemModels,
                        mealRecipeModels: result.mealRecipeModels,
                        portionCost: result.portionCost,
                        portionWeight: result.portionWeight,
                        recipeItemsCost: result.recipeItemsCost,
                    }),
                })));
            }
        })
            .catch(console.error);
    };
}
export function setGrade(id, grade) {
    return (dispatch) => {
        return postJson(pathCombine("/recipe", "/SetGrade?grade=" + grade), id).then((resp) => {
            dispatch(updateCurrentPage((current) => Object.assign(current, {
                grade: resp.grade,
                voteCount: resp.voteCount,
                userVoted: resp.userVoted,
            })));
        });
    };
}
function failedPromiseHandler(e) {
    console.error(e);
    return Promise.reject(null);
}
